import React from 'react';
import Highcharts from 'highcharts';
import { Chart } from '../Chart';
import { useChartSettings } from '../hooks/useChartSettings';
import { axisSettings, AxisType, commonSettings } from '../charts.constants';
import { theme } from '../../../../theme/theme';

export const chartSettings: Highcharts.Options = {
  ...commonSettings,

  chart: {
    type: 'area',
    spacingTop: 20,
    spacingRight: 20,
    style: {
      fontFamily: theme.fontFamily,
    },
  },

  plotOptions: {
    area: {
      lineWidth: 2,
      states: {
        hover: {
          lineWidth: 3,
        },
      },
      marker: {
        enabled: false,
      },
      fillOpacity: 0,
    },
  },
};

interface LineChartProps {
  series: {
    name: string;
    data: number[][];
    color?: string;
    visible?: boolean;
  }[];
  customSettings?: Record<string, any>;
  xAxisType?: AxisType;
  yAxisType?: AxisType;
}

export const LineChart: React.FC<LineChartProps> = ({
  series,
  customSettings = {},
  xAxisType = 'decimal',
  yAxisType = 'decimal',
}) => {
  const settings = useChartSettings({
    series,
    settings: chartSettings,
    customSettings: {
      ...customSettings,
      xAxis: {
        ...customSettings?.xAxis,
        ...axisSettings[xAxisType],
      },
      yAxis: {
        ...customSettings?.yAxis,
        ...axisSettings[yAxisType],
      },
    },
  });

  return <Chart options={settings} />;
};
